import { render } from "./VideoThumbnail.vue?vue&type=template&id=8a5ffcf8"
import script from "./VideoThumbnail.vue?vue&type=script&lang=js"
export * from "./VideoThumbnail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__